import { SelectOption } from '@fleet-beat/core';

export enum ProviderTimestampModeEnum {
  ABSOLUTE = 'absolute',
  CWC = 'camera_wall_clock',
}

export const ProviderTimestampModeOptions: SelectOption[] = [
  { value: ProviderTimestampModeEnum.ABSOLUTE, label: 'Absolute' },
  { value: ProviderTimestampModeEnum.CWC, label: 'Camera wall clock' },
];

export const SafetyEventsOptions: SelectOption[] = [
  { value: '1001', label: 'Device Normal', data: 'INFO' },
  { value: '1002', label: 'External Power Off', data: 'HIGH' },
  { value: '1003', label: 'Device Power On', data: 'INFO' },
  { value: '1004', label: 'External Power Undervoltage', data: 'MEDIUM' },
  { value: '1005', label: 'Low Power Protection', data: 'HIGH' },
  { value: '1006', label: 'Manual Shutdown', data: 'MEDIUM' },
  { value: '1007', label: 'Airplane Mode', data: 'MEDIUM' },
  { value: '1008', label: 'Device Removed', data: 'HIGH' },
  { value: '1009', label: 'Low Power Shutdown', data: 'HIGH' },
  { value: '1010', label: 'Cover Opened', data: 'HIGH' },
  { value: '1011', label: 'Internal Battery Undervoltage', data: 'MEDIUM' },
  { value: '1012', label: 'About To Sleep', data: 'INFO' },
  { value: '1013', label: 'Device Plugged Out', data: 'HIGH' },
  { value: '1014', label: 'Device Plugged In', data: 'INFO' },
  { value: '1015', label: 'Land Transport Mode', data: 'INFO' },
  { value: '1016', label: 'Water Transport Mode', data: 'INFO' },
  { value: '1017', label: 'Stationary Mode', data: 'INFO' },
  { value: '1018', label: 'Deep Sleep', data: 'INFO' },
  { value: '1019', label: 'Cover Or Collision', data: 'HIGH' },
  { value: '1020', label: 'Light Detected', data: 'INFO' },
  { value: '1021', label: 'Active Offline', data: 'MEDIUM' },
  { value: '1022', label: 'Device Locked', data: 'INFO' },
  { value: '1023', label: 'Device Unlocked', data: 'INFO' },
  { value: '1024', label: 'Unexpected Unlock', data: 'MEDIUM' },
  { value: '1025', label: 'Unlock Failed', data: 'LOW' },
  { value: '1026', label: 'Out Of Range', data: 'MEDIUM' },
  { value: '1027', label: 'Stationary Too Long', data: 'LOW' },
  { value: '1028', label: 'Battery Fully Charged', data: 'INFO' },
  { value: '1029', label: 'Battery Error', data: 'HIGH' },
  { value: '1030', label: 'Battery Temperature High', data: 'MEDIUM' },
  { value: '1031', label: 'Battery Charging Started', data: 'INFO' },
  { value: '1032', label: 'Battery Charging Stopped', data: 'INFO' },
  { value: '1033', label: 'Battery Almost Full', data: 'INFO' },
  { value: '1034', label: 'Battery Charge Complete', data: 'INFO' },
  { value: '1035', label: 'External Voltage High', data: 'MEDIUM' },
  { value: '1036', label: 'Voltage Exception', data: 'MEDIUM' },
  { value: '1037', label: 'Device Signed In', data: 'INFO' },
  { value: '1038', label: 'Device Signed Out', data: 'INFO' },
  { value: '1039', label: 'Device Installed', data: 'INFO' },
  { value: '1040', label: 'Temperature Rising', data: 'MEDIUM' },
  { value: '1041', label: 'Temperature Dropping', data: 'MEDIUM' },
  { value: '1042', label: 'Device Restarted', data: 'INFO' },
  { value: '1043', label: 'Device Tilted', data: 'MEDIUM' },
  { value: '1044', label: 'Device Muted', data: 'INFO' },
  { value: '1101', label: 'Geofence Entry', data: 'LOW' },
  { value: '1102', label: 'Geofence Exit', data: 'LOW' },
  { value: '1103', label: 'GNSS Dead Zone Entry', data: 'MEDIUM' },
  { value: '1104', label: 'GNSS Dead Zone Exit', data: 'INFO' },
  { value: '1105', label: 'First Fix', data: 'INFO' },
  { value: '1106', label: 'Route In/Out', data: 'MEDIUM' },
  { value: '1107', label: 'Road Section Time Issue', data: 'MEDIUM' },
  { value: '1108', label: 'Route Deviation', data: 'MEDIUM' },
  { value: '1109', label: 'External GNSS Antenna Disconnected', data: 'HIGH' },
  { value: '1110', label: 'GNSS Module Failure', data: 'HIGH' },
  { value: '1111', label: 'GNSS Antenna Disconnected', data: 'HIGH' },
  { value: '1112', label: 'GNSS Antenna Short', data: 'MEDIUM' },
  { value: '1113', label: 'GNSS Module Error', data: 'HIGH' },
  { value: '1114', label: 'UBI GNSS Chip Error', data: 'HIGH' },
  { value: '1115', label: 'Geofence Speeding', data: 'MEDIUM' },
  { value: '1116', label: 'Long Time To Fix', data: 'LOW' },
  { value: '1151', label: 'Exit Geofence(Platform)', data: 'INFO' },
  { value: '1150', label: 'Enter Geofence(Platform)', data: 'INFO' },
  { value: '1201', label: 'Fuel Power Reconnected', data: 'INFO' },
  { value: '1202', label: 'Fuel Power Cut Off', data: 'HIGH' },
  { value: '1203', label: 'Engine Failure', data: 'HIGH' },
  { value: '1204', label: 'Vehicle Battery Undervoltage', data: 'MEDIUM' },
  { value: '1205', label: 'Long Parking', data: 'LOW' },
  { value: '1206', label: 'High Water Temperature', data: 'HIGH' },
  { value: '1207', label: 'Ignition On', data: 'INFO' },
  { value: '1208', label: 'Ignition Off', data: 'INFO' },
  { value: '1209', label: 'VSS Failure', data: 'HIGH' },
  { value: '1210', label: 'Illegal Ignition', data: 'HIGH' },
  { value: '1211', label: 'Engine On', data: 'INFO' },
  { value: '1213', label: 'Speed Normal', data: 'INFO' },
  { value: '1214', label: 'ADC1 Voltage High', data: 'MEDIUM' },
  { value: '1215', label: 'ADC1 Voltage Low', data: 'MEDIUM' },
  { value: '1216', label: 'ADC1 Voltage Rising', data: 'MEDIUM' },
  { value: '1217', label: 'ADC1 Voltage Dropping', data: 'MEDIUM' },
  { value: '1218', label: 'Live Wire Exception', data: 'HIGH' },
  { value: '1219', label: 'Door Status Abnormal', data: 'MEDIUM' },
  { value: '1220', label: 'Door Opened', data: 'INFO' },
  { value: '1221', label: 'Door Closed', data: 'INFO' },
  { value: '1222', label: 'Low Fuel', data: 'LOW' },
  { value: '1223', label: 'Fuel Level Abnormal', data: 'MEDIUM' },
  { value: '1224', label: 'Fuel Level Increased', data: 'MEDIUM' },
  { value: '1225', label: 'Fuel Level Dropped', data: 'MEDIUM' },
  { value: '1226', label: 'Exit Transport Mode', data: 'INFO' },
  { value: '1227', label: 'Idling Too Long', data: 'LOW' },
  { value: '1228', label: 'Illegal Door Opening', data: 'MEDIUM' },
  { value: '1229', label: 'Mirror Vibration', data: 'LOW' },
  { value: '1230', label: 'Truck Opened', data: 'MEDIUM' },
  { value: '1301', label: 'Speeding', data: 'MEDIUM' },
  { value: '1302', label: 'Harsh Acceleration', data: 'LOW' },
  { value: '1303', label: 'Sharp Left Turn', data: 'LOW' },
  { value: '1304', label: 'Sharp Right Turn', data: 'LOW' },
  { value: '1305', label: 'Hard Braking', data: 'LOW' },
  { value: '1306', label: 'Sharp Turn', data: 'LOW' },
  { value: '1307', label: 'Fatigue Warning', data: 'MEDIUM' },
  { value: '1308', label: 'Daily Driving Timeout', data: 'HIGH' },
  { value: '1309', label: 'Over Driving', data: 'MEDIUM' },
  { value: '1401', label: 'Emergency SOS', data: 'CRITICAL' },
  { value: '1402', label: 'Fall Down', data: 'HIGH' },
  { value: '1403', label: 'Body Temperature Abnormal', data: 'HIGH' },
  { value: '1404', label: 'Danger Warning', data: 'HIGH' },
  { value: '1501', label: 'Unexpected Vibration', data: 'MEDIUM' },
  { value: '1502', label: 'Unexpected Movement', data: 'HIGH' },
  { value: '1503', label: 'Collision', data: 'HIGH' },
  { value: '1504', label: 'Rollover', data: 'CRITICAL' },
  { value: '1505', label: 'Stability Exception', data: 'HIGH' },
  { value: '1506', label: 'Attitude Exception', data: 'MEDIUM' },
  { value: '1507', label: 'Airbag Deployed', data: 'CRITICAL' },
  { value: '1508', label: 'Vehicle May Be Stolen', data: 'HIGH' },
  { value: '1509', label: 'Unexpected Start', data: 'HIGH' },
  { value: '1510', label: 'Unexpected Towing', data: 'HIGH' },
  { value: '1511', label: 'Suspected Fuel Theft', data: 'MEDIUM' },
  { value: '1512', label: 'Vehicle Stolen', data: 'CRITICAL' },
  { value: '1513', label: 'Vehicle Finding', data: 'INFO' },
  { value: '1635', label: 'SD Card Fault', data: 'HIGH' },
  { value: '1636', label: 'DMS Camera Communication Abnormality', data: 'HIGH' },
  { value: '1601', label: 'SIM Changed', data: 'MEDIUM' },
  { value: '1602', label: 'SD Card Inserted', data: 'INFO' },
  { value: '1603', label: 'SD Card Removed', data: 'MEDIUM' },
  { value: '1604', label: 'SD Card Corrupted', data: 'HIGH' },
  { value: '1605', label: 'SD Card Mounted', data: 'INFO' },
  { value: '1606', label: 'No SD Card', data: 'MEDIUM' },
  { value: '1607', label: 'Video Signal Lost', data: 'MEDIUM' },
  { value: '1608', label: 'Video Blocked', data: 'MEDIUM' },
  { value: '1609', label: 'Storage Failure', data: 'HIGH' },
  { value: '1610', label: 'LCD Failure', data: 'HIGH' },
  { value: '1611', label: 'TTS Failure', data: 'MEDIUM' },
  { value: '1612', label: 'Camera Failure', data: 'HIGH' },
  { value: '1613', label: 'IC Card Failure', data: 'MEDIUM' },
  { value: '1614', label: 'Charger Connected', data: 'INFO' },
  { value: '1615', label: 'DLT Card Login', data: 'INFO' },
  { value: '1616', label: 'DLT Card Logout', data: 'INFO' },
  { value: '1617', label: 'DLT Unregistered Card', data: 'MEDIUM' },
  { value: '1618', label: 'No USB Camera', data: 'MEDIUM' },
  { value: '1619', label: 'Temp Or Humidity Abnormal', data: 'MEDIUM' },
  { value: '1620', label: 'Temperature Recovered', data: 'INFO' },
  { value: '1621', label: 'Environment Abnormal', data: 'MEDIUM' },
  { value: '1622', label: 'Fuel Sensor Comm Error', data: 'HIGH' },
  { value: '1623', label: 'Fuel Sensor Comm Resumed', data: 'INFO' },
  { value: '1624', label: 'Temp Sensor Comm Error', data: 'MEDIUM' },
  { value: '1625', label: 'Temp Sensor Error', data: 'MEDIUM' },
  { value: '1626', label: 'Temp Sensor Timeout', data: 'MEDIUM' },
  { value: '1627', label: 'RFID Sensor Error', data: 'MEDIUM' },
  { value: '1628', label: 'Memory Card Space Low', data: 'MEDIUM' },
  { value: '1629', label: 'RFID Card Swipe', data: 'INFO' },
  { value: '1630', label: '3D Acceleration Error', data: 'HIGH' },
  { value: '1631', label: 'UBI Sensor Chip Error', data: 'HIGH' },
  { value: '1632', label: 'UBI Encrypted IC Error', data: 'HIGH' },
  { value: '1633', label: 'Flash Error', data: 'HIGH' },
  { value: '1634', label: 'CAN Module Error', data: 'HIGH' },
  { value: '1701', label: 'Forward Collision Warning', data: 'HIGH' },
  { value: '1702', label: 'Lane Departure Warning', data: 'MEDIUM' },
  { value: '1703', label: 'Headway Monitor Warning', data: 'MEDIUM' },
  { value: '1704', label: 'Pedestrian Collision Warning', data: 'HIGH' },
  { value: '1705', label: 'Lane Change Warning', data: 'LOW' },
  { value: '1706', label: 'Road Sign Overrun', data: 'MEDIUM' },
  { value: '1707', label: 'Obstacle Warning', data: 'MEDIUM' },
  { value: '1708', label: 'Road Sign Recognition', data: 'INFO' },
  { value: '1709', label: 'Active Capture', data: 'INFO' },
  { value: '1822', label: 'Driver Eyes Closed', data: 'MEDIUM' },
  { value: '1823', label: 'Face Recognition Succeeded', data: 'INFO' },
  { value: '1824', label: 'Face Recognition Failed', data: 'MEDIUM' },
  { value: '1825', label: 'Face Data Uploaded', data: 'INFO' },
  { value: '1801', label: 'Fatigue Driving', data: 'HIGH' },
  { value: '1802', label: 'Using Phone', data: 'MEDIUM' },
  { value: '1803', label: 'Smoking', data: 'LOW' },
  { value: '1804', label: 'Driver Distraction', data: 'MEDIUM' },
  { value: '1805', label: 'No Face Detected', data: 'HIGH' },
  { value: '1806', label: 'Camera Blocked', data: 'HIGH' },
  { value: '1807', label: 'Seatbelt Unfastened', data: 'MEDIUM' },
  { value: '1808', label: 'Sunglasses Detected', data: 'LOW' },
  { value: '1809', label: 'Hands Off Wheel', data: 'HIGH' },
  { value: '1810', label: 'Answering Phone', data: 'MEDIUM' },
  { value: '1811', label: 'Auto Capture', data: 'INFO' },
  { value: '1812', label: 'Driver Change', data: 'INFO' },
  { value: '1813', label: 'DSM Calibration Anomaly', data: 'MEDIUM' },
  { value: '1814', label: 'Frequent Blinking', data: 'MEDIUM' },
  { value: '1815', label: 'Yawning', data: 'MEDIUM' },
  { value: '1816', label: 'Seatbelt Fastened', data: 'INFO' },
  { value: '1817', label: 'Capture Completed', data: 'INFO' },
  { value: '1818', label: 'Driver Info Changed', data: 'INFO' },
  { value: '1819', label: 'Face Alignment Error', data: 'LOW' },
  { value: '1820', label: 'Head Lowered', data: 'MEDIUM' },
  { value: '1821', label: 'Driver Drinking', data: 'CRITICAL' },
  { value: '9901', label: 'Pseudo Base Station', data: 'LOW' },
  { value: '9902', label: 'Suspected Herd Departure', data: 'LOW' },
  { value: '9903', label: 'Away From Beacon', data: 'LOW' },
  { value: '9904', label: 'Left Herd', data: 'MEDIUM' },
  { value: '9905', label: 'Voice Control', data: 'INFO' },
  { value: '9906', label: 'Identification', data: 'MEDIUM' },
  { value: '9907', label: 'Key Press Event', data: 'INFO' },
  { value: '9908', label: 'Exit Defense Mode', data: 'INFO' },
  { value: '9909', label: 'Enter Defense Mode', data: 'INFO' },
  { value: '9911', label: 'Reserved 1', data: 'LOW' },
  { value: '9912', label: 'Reserved 2', data: 'LOW' },
  { value: '9913', label: 'Reserved 3', data: 'LOW' },
  { value: '9914', label: 'Pet Lost', data: 'MEDIUM' },
  { value: '9915', label: 'Package Opened', data: 'MEDIUM' },
  { value: '9916', label: 'Pulse Exception', data: 'HIGH' },
  { value: '9917', label: 'Near Bluetooth Beacon', data: 'INFO' },
  { value: '9918', label: 'Bluetooth MAC Found', data: 'INFO' },
  { value: '9919', label: 'No Bluetooth MAC', data: 'INFO' },
  { value: '9920', label: 'INPUT1 On', data: 'INFO' },
  { value: '9921', label: 'INPUT1 Off', data: 'INFO' },
  { value: '9922', label: 'INPUT2 On', data: 'INFO' },
  { value: '9923', label: 'INPUT2 Off', data: 'INFO' },
  { value: '9924', label: 'Motion Start', data: 'INFO' },
  { value: '9925', label: 'Motion Stop', data: 'INFO' },
  { value: '9926', label: 'File Uploaded', data: 'INFO' },
  { value: '9927', label: 'Loud Ambient Sound', data: 'LOW' },
  { value: '9928', label: 'Data Usage Exception', data: 'MEDIUM' },
  { value: 'impact', label: 'Impact', data: 'HIGH' },
  { value: 'parking-impact', label: 'Parking Impact', data: 'HIGH' },
  { value: 'harsh-driving', label: 'Harsh Driving', data: 'LOW' },
  { value: 'impact-driving', label: 'Impact Driving', data: 'HIGH' },
  { value: 'impact-parking', label: 'Impact Parking', data: 'HIGH' },
  { value: 'harsh-acceleration', label: 'Harsh Acceleration', data: 'LOW' },
  { value: 'harsh-braking', label: 'Harsh Braking', data: 'LOW' },
  { value: 'harsh-cornering', label: 'Harsh Cornering', data: 'LOW' },
  { value: 'forward-collision-warning', label: 'FCW', data: 'HIGH' },
  { value: 'following-distance-warning', label: 'Tailgating', data: 'MEDIUM' },
  { value: 'lane-departure-warning', label: 'LDW', data: 'MEDIUM' },
  { value: 'stop-and-go', label: 'Stop and Go', data: 'MEDIUM' },
  { value: 'pedestrian-collision-warning', label: 'Pedestrian Collision', data: 'HIGH' },
  { value: 'fatigue-driving', label: 'Fatigue', data: 'HIGH' },
  { value: 'driver-distraction', label: 'Distraction', data: 'MEDIUM' },
  { value: 'phone-usage', label: 'Phoning', data: 'MEDIUM' },
  { value: 'seatbelt-unfastened', label: 'Seatbelt Unfastened', data: 'MEDIUM' },
  { value: 'camera-obstructed', label: 'Lens Covered', data: 'HIGH' },
  { value: 'speeding', label: 'Speeding', data: 'MEDIUM' },
  { value: 'speed-camera-violation', label: 'Speed Camera Violation', data: 'MEDIUM' },
  { value: 'rolling-stop', label: 'Rolling Stop', data: 'MEDIUM' },
  { value: 'railroad-crossing-violation', label: 'Railroad Crossing', data: 'MEDIUM' },
  { value: 'school-zone-speeding', label: 'School Zone Speeding', data: 'MEDIUM' },
  { value: 'speed-limit-warning', label: 'Speed Limit', data: 'LOW' },
  { value: 'io-cover-removed', label: 'I/O Cover Removed', data: 'HIGH' },
  { value: 'manual-trigger', label: 'Manual Trigger', data: 'INFO' },
];
